import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Turn Prospects into Paying Clients with WhatsApp Conversations",
    points: [
      "Welcome new leads with friendly messages to build trust and verify interest.",
      "Follow up on service requests to collect detailed project information quickly.",
      "Use automated replies to handle common questions and speed up responses.",
      "Promote your latest services and offerings through targeted WhatsApp broadcasts.",
      "Share professional project proposals and quotes to close deals faster.",
      "Make payments easy with WhatsApp checkout links for freelance and consulting fees.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Freelancer/Freelancer_2.png",
  },
  {
    heading: "Stay Connected with Clients Through WhatsApp Updates",
    points: [
      "Send regular progress reports so clients always know where their projects stand.",
      "Share success stories from previous projects to inspire confidence and collaboration.",
      "Exchange project files, designs, and documents securely on an encrypted platform.",
      "Ask for referrals by offering incentives like discounts on future invoices.",
    ],
    buttonText: "Meta Policy for Freelancer",
    buttonLink:"https://transparency.meta.com/en-gb/policies/ad-standards/deceptive-content/prohibited-financial-products-and-services/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Freelancer/Freelancer_3.png",
  },
  {
    heading: "Deliver Exceptional Service and Build Client Loyalty",
    points: [
      "Organize chats with labels to keep everything neat and easy to find.",
      "Set up away messages to let clients know when you’re unavailable.",
      "Gather feedback and reviews from clients to refine your services and build trust.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Freelancer/Freelancer_4.png",
  },
  // {
  //   heading: "Improve your work-life balance and scale your freelance business with WhatsApp.",
  //   points: [
  //     "Save time by automating responses to common queries, managing orders, and sending bulk notifications through ChatMitra’s WhatsApp API.",
  //     "Build stronger relationships with clients by sending tailored messages, greetings, and updates directly on WhatsApp.",
  //     "Use ChatMitra’s insights to understand customer behavior, optimize strategies, and make data-driven decisions for business growth",
  //   ],
  //   buttonText: "Get Start - No Credit Card Required",
  //   image: "",
  // },
];

const Freelancercycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-pink-200 to-pink-300 py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-800">How Freelancers and Consultants Win with WhatsApp</h1>
          <div className="mt-4 mb-6 flex justify-center">
            <span className="w-20 h-1 bg-gray-400 rounded-full"></span>
          </div>
          <p className="text-lg text-gray-600">See how professionals use WhatsApp to automate tasks, engage clients, and drive sales for better results.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
                <a
                href={item.buttonLink}
                className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
              >
                {item.buttonText}
              </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Freelancercycle;